/**
 * Datos institucionales y de contacto de Mostrando México.
 * Fuente: análisis del sitio público www.mostrandomexico.com (oct 2025).
 * No inventar datos — los campos `pending` requieren validación manual.
 */

export const SITE = {
  legalFooter: {
    text: "MOSTRANDOMEXICO SAS DE CV · RFC MOS2401231W6 · Blvd. Kukulcán 9, 77500 Cancún, Quintana Roo, México",
    rnt: "" as string,
  },
  brand: {
    name: "Mostrando México",
    legalName: "Company Mostrando Mexico",
    tagline: "Tours auténticos · Vuelos · Hoteles",
    description:
      "Tours y experiencias auténticas en México: Cancún, Riviera Maya, Cozumel, Tulum, Bacalar, Mérida, Puerto Vallarta y más.",
    yearFounded: null as number | null, // pendiente
  },
  contact: {
    phone: "+52 998 338 1476",
    phoneTel: "+529983381476",
    whatsapp: "+529983381476",
    whatsappUrl: "https://wa.me/529983381476",
    whatsappPrettyUrl: "https://wa.me/529983381476?text=Hola%20Mostrando%20M%C3%A9xico%2C%20me%20gustar%C3%ADa%20m%C3%A1s%20informaci%C3%B3n",
    email: "info@mostrandomexico.mx",
    emails: [
      { label: "Información general", address: "info@mostrandomexico.mx" },
      { label: "Asistente / Maya IA", address: "info@mostrandomexico.mx" },
      { label: "Reservaciones", address: "info@mostrandomexico.mx" },
    ],
    assistantEmail: "info@mostrandomexico.mx",
    address: "Boulevard Kukulcan, Centro de Convenciones, Hotel Zone, Km 9, Cancún, Q.R., México",
    hours: "Atención al cliente 24/7",
  },
  social: {
    facebook: "https://www.facebook.com/mostrandomexicocorporativo" as string | null,
    instagram: "https://www.instagram.com/mostrandomexico" as string | null,
    tiktok: null as string | null,
    youtube: null as string | null,
    twitter: null as string | null,
    tripadvisor: "https://www.tripadvisor.com.mx/" as string | null,
  },
  policies: {
    freeCancellationHours: 48,
    discounts: [
      { code: "NACIONAL", off: "20%", audience: "Residentes nacionales en tours de Cancún" },
      { code: "TRAVEL", off: "10%", audience: "Visitantes internacionales reservando con 7 días de anticipación" },
    ],
    payments: ["VISA", "MasterCard", "American Express", "Diners Club", "Mercado Pago"],
  },
  destinations: [
    { slug: "cancun", name: "Cancún", note: "Hub principal · zona hotelera" },
    { slug: "riviera-maya", name: "Riviera Maya" },
    { slug: "tulum", name: "Tulum" },
    { slug: "cozumel", name: "Cozumel" },
    { slug: "bacalar", name: "Bacalar" },
    { slug: "holbox", name: "Holbox" },
    { slug: "merida", name: "Mérida" },
    { slug: "chichen-itza", name: "Chichén Itzá" },
    { slug: "valladolid", name: "Valladolid" },
    { slug: "puerto-vallarta", name: "Puerto Vallarta" },
  ],
  partners: ["Bokun", "TripAdvisor", "Civitatis", "THA 2026 Winner"],
} as const;

export type SiteConfig = typeof SITE;
